/**
 * Percent-encode a single URL path segment for use in a /code/... route.
 *
 * NOTE this does NOT reliably protect a segment that is exactly "." or ".."
 * (see VFS_ROOT_URL_ALIAS below for why) — it's still applied for defense in
 * depth on segments other than the service name, and to escape slashes etc.
 */
export function encodePathSegment(segment) {
  return encodeURIComponent(segment);
}

// A vfs-root-only project's synthetic service name is literally "." (see
// Canvas.jsx's loadConfiguration root-manifest detection). A URL path segment
// that is exactly "." or ".." gets collapsed as a dot-segment — and NOT only
// by the browser's own RFC 3986 normalization, which operates on raw
// (still-percent-encoded) segments and would leave a percent-encoded "%2E"
// alone: react-router's own path-resolution logic (used by navigate() to
// support relative "../foo"-style links) decodes segments and re-applies its
// own dot-collapsing on the DECODED value, so even `encodeURIComponent('.')`
// -> '%2E' still gets collapsed back to a bare "." and removed internally.
// The only reliable fix is to never let the literal string "." reach the URL
// as its own path segment — swap it for an opaque alias when building the
// URL, and swap back when reading the service-name segment out of the URL.
const VFS_ROOT_URL_ALIAS = '_root_';

/** Encode a service/microservice name for use as a URL path segment. */
export function encodeServiceNameForUrl(serviceName) {
  return serviceName === '.' ? VFS_ROOT_URL_ALIAS : encodeURIComponent(serviceName);
}

/** Decode a service/microservice name read back from a URL path segment (already url-decoded by the router). */
export function decodeServiceNameFromUrl(urlSegment) {
  return urlSegment === VFS_ROOT_URL_ALIAS ? '.' : urlSegment;
}
